import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFDelta2VideoPlayer from '@/components/UI/svg/Delta2/Icon/EFDelta2VideoPlayer';
import { youtubeMap } from '@/constants/delta2max';
import { STAGES } from '@/constants/delta2max';
import Emarsys from '@/components/SignUpForm/Emarsys';

const Icon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="0.5" y="0.5" width="19" height="19" stroke="#30BF00" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.59512 11.9621L6.07317 9.60421L5 10.6147L8.59512 14L16 7.02737L14.9268 6L8.59512 11.9621Z"
                fill="#30BF00"
            />
        </svg>
    );
};

export default function A({ stage }: any) {
    const { useLang, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('delta2max.teaser');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const [step, setStep] = useState(1); // 1 订阅 2 订阅成功

    const playerVideo = () => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 Max | UX video',
            position: stage === STAGES.DETAIL ? 'Product Detail_1' : 'Product_1',
            __btn_id1: css.d2xTeaserA,
            __btn_id2: t('sec1_watch'),
        });
    };

    const successCallBack = (email: string) => {
        setStep(2);
        // setTimeout(() => {
        //     setStep(1);
        // }, 3000);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('sec1_sign'),
                status: 'success',
                tag: 'None',
                product_name: 'EcoFlow DELTA 2 Max',
            });
            const url = `https://media.ecoflow.com/u/register.php?CID=1045840001&f=1215&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=${email.trim()}&inp_4433=1&inp_9104=1`;
            window.open(url, '_blank');
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('sec1_sign'),
            status: 'fail',
            tag: 'None',
            product_name: 'EcoFlow DELTA 2 Max',
        });
    };

    return (
        <div className={`d2x-teaser-A ${css.d2xTeaserA} GtmModuleDate-section`} data-section-id={css.d2xTeaserA} data-section-title={t('sec1_title')}>
            <NextImage src={require('@publicLocal/delta2max/teaser/h5/eu/au_1.jpg')} alt={t('sec1_title')} aria-label={t('sec1_title')} />
            <div className={`text-wrapper ${stage === STAGES.TEASER ? 'teaser' : 'detail'}`}>
                <p className="title">{t('sec1_title')}</p>
                <p className="desc date">{t('sec1_subtitle')}</p>
                {stage === STAGES.TEASER && (
                    <>
                        <p className="date">{t('sec1_date')}</p>
                        <Emarsys
                            source={'Web new product sub'}
                            submitText={t('sec1_sign')}
                            placeholder={t('sec1_placeholder')}
                            successCallback={successCallBack}
                            errorCallback={errorCallback}
                        />
                    </>
                )}
                {stage !== STAGES.TEASER && (
                    <Link
                        href="https://au.ecoflow.com/products/delta-2-max-portable-power-station"
                        className="shop-now GtmModuleData-btn-href"
                        datalayer={{
                            __btn_id1: css.d2xTeaserA,
                            __btn_id2: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                        }}
                    >
                        SHOP NOW
                    </Link>
                )}
                {step === 2 && (
                    <div className="success-tips">
                        <Icon />
                        <p className="tips">Thanks for signing up! Please check your email to receive a 5% early bird coupon code.</p>
                    </div>
                )}
                <div className="video-btn GtmModuleData-btn-text" hidden onClick={playerVideo}>
                    <p>{t('sec1_watch')}</p>
                    <div className="video-icon">
                        <EFDelta2VideoPlayer />
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
